import { render, staticRenderFns } from "./PProjectListForPublicCorporationProfile.vue?vue&type=template&id=30937f28&"
import script from "./PProjectListForPublicCorporationProfile.vue?vue&type=script&lang=ts&"
export * from "./PProjectListForPublicCorporationProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports